import { render, staticRenderFns } from "./RegiestDialog.vue?vue&type=template&id=a9471f24&scoped=true"
import script from "./RegiestDialog.vue?vue&type=script&lang=js"
export * from "./RegiestDialog.vue?vue&type=script&lang=js"
import style0 from "./RegiestDialog.vue?vue&type=style&index=0&id=a9471f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9471f24",
  null
  
)

export default component.exports